import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {gemsRoutes} from './gems.routes';
import {RouterModule} from '@angular/router';
import {CdkTableModule} from '@angular/cdk/table';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatStepperModule} from '@angular/material/stepper';
import {FuseSharedModule} from '@barebone-fuse/@fuse/shared.module';
import {FuseSearchBarModule} from '@barebone-fuse/@fuse/components';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatDividerModule} from '@angular/material/divider';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {SharedModule} from '@shared/shared.module';
import {CoreModule} from '@core/core.module';
import {GemsDynamicComponentHelper} from '@features/gems/gems-dynamic-component-helper';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {GemsHandler} from '@features/gems/services/gems-handler';
import { GemsAnalyticsComponent } from './components/gems-analytics/gems-analytics.component';
import {GemsHistoryHandler} from '@features/gems/services/gems-history-handler';
import {GemsHistoryApiProvider} from '@features/gems/gems-history-api-provider';
import {ContactsModule} from '@features/contacts/contacts.module';


@NgModule({
  declarations: [
    GemsAnalyticsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(gemsRoutes),
    CdkTableModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    FuseSharedModule,
    FuseSearchBarModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatTooltipModule,
    SharedModule,
    CoreModule,
    ContactsModule
  ]
})
export class GemsModule {
  constructor(private commandService: CommandService,
              private platformApiProvider: PlatformApiProvider,
              private gemsHandler: GemsHandler,
              private gemsHistoryHandler: GemsHistoryHandler) {
    GemsDynamicComponentHelper.init();
    GemsDynamicComponentHelper.register('GemsHandler', gemsHandler);
    GemsDynamicComponentHelper.register('GemsHistoryHandler', gemsHistoryHandler);
    const command = new PlatformCommand('GemsEntityLinkCommand', 'FileStoreApi');
    command.projectId = '[PROJECT_ID]';
    this.commandService.registrPlatformLinkCommand('/gems/entities', command);
    this.platformApiProvider.registerDefault('FileStoreApi', '/gems/entities');

    const gemsAnalyticsPlatformCommand = new PlatformCommand('GemsAnalyticsLinkCommand', 'FileStoreApi');
    gemsAnalyticsPlatformCommand.projectId = '[PROJECT_ID]';
    gemsAnalyticsPlatformCommand.fieldValues['ReportType'] = 'GEMS';
    gemsAnalyticsPlatformCommand.fieldValues['BreadcrumbText'] = 'Computershare~Analytics';
    gemsAnalyticsPlatformCommand.fieldValues['BreadcrumbLink'] = '/gems/analytics~/gems/analytics';
    this.commandService.registrPlatformLinkCommand('/gems/analytics', gemsAnalyticsPlatformCommand);
    this.platformApiProvider.registerDefault('VisualizerApi', '/gems/analytics');

    this.platformApiProvider.registerAtTop(new GemsHistoryApiProvider());
  }
}

